import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async counter => { // 'miles-counter'
	const 	section = h('section').Node,
			rate = 0.1 / parseFloat(counter.getAttribute('rate')),
			kRate = rate * 1000,
			count = [...parseInt(counter.getAttribute('miles')).toString().split(''),'0'].map( miles => {
				let digits = digitDom();
				section.appendChild(digits);
				return {cur: 0, target: parseInt(miles), digits};
			});

	counter.appendChild(section);

	[...section.querySelectorAll('digit-holder:last-child > span')].forEach(span => domWrap(span).css({transition: `transform ${rate}s linear`}));

	setTimeout(() => {
		let final = 0;
		count.forEach( digit => {
			let random = Math.floor(Math.random() * 750) + 10;
			while (digit.cur < digit.target) {
				digit.cur = digit.cur + 1;
				let delay = Math.floor(750 / ((digit.target - digit.cur) + 2)) + random;

				final = Math.max(final,delay);

				setTimeout(target => digit.digits.setAttribute('current',target),delay, parseInt(digit.cur.toString()));
			}
		});
		setTimeout(()=>{
			counter();
			function counter(){
				let rerun = false;
				count.reduceRight((carry,digit) => {
					let inc = 0;
					digit.cur = digit.cur + carry;
					if(digit.cur > 9){
						inc = 1;
						digit.cur = 0;
						rerun = true;
					}
					if(inc === 1){
						digit.digits.setAttribute('current',10);
						setTimeout(()=>digit.digits.setAttribute('current',0),kRate);
					}
					else {
						digit.digits.setAttribute('current',digit.cur);
					}
					return inc;
				},1);
				setTimeout(counter,kRate + (rerun ? 20 : 0));
			}	
		},final + 250);
	},250);			
}

function digitDom(){
	return h('digit-holder', Object.keys([...Array(11)]).map( num => h(`span number="${num}"`).toString()).join('')).Node;
}